// extracted by mini-css-extract-plugin
export default {"subtitle":"CX_rZV"};